import { Route, Outlet } from 'react-router-dom';
import { ProtectedRoute } from 'ProtectedRoute';
import { routeAllowedIfStreamAvailableOffline } from 'OfflineMode';
import { StreamDashboardComponent } from './components/StreamDashboardComponent';
import { StreamCompletedComponent } from './components/StreamCompletedComponent';
import { STREAM_DASHBOARD_ROUTES } from './routes';

// Re-export routes for backwards compatibility
export { STREAM_DASHBOARD_ROUTES } from './routes';

export function configureStreamDashboardRoutes() {
    return [
        {
            routes: STREAM_DASHBOARD_ROUTES,
            config: {},
        },
    ];
}

export function getStreamDashboardRoutes() {
    return (
        <Route id="stream-dashboard-routes" element={<Outlet />}>
            <Route
                path={STREAM_DASHBOARD_ROUTES.COURSE_TITLE_STREAM.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted" allowedOffline={routeAllowedIfStreamAvailableOffline}>
                        <StreamDashboardComponent />
                    </ProtectedRoute>
                }
            />
            <Route
                path={STREAM_DASHBOARD_ROUTES.COURSE_STREAM.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted" allowedOffline={routeAllowedIfStreamAvailableOffline}>
                        <StreamDashboardComponent />
                    </ProtectedRoute>
                }
            />
            <Route
                path={STREAM_DASHBOARD_ROUTES.STREAM_COMPLETED.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted" allowedOffline={routeAllowedIfStreamAvailableOffline}>
                        <StreamCompletedComponent />
                    </ProtectedRoute>
                }
            />
        </Route>
    );
}
